<template>
  <div class="sdglist-container">
    <div v-for="s in programmePoints" :key="s.id" class="tile" @click="goto(s)">
      <div class="tile-header">
        <div class="vote-container">
          <div class="vote">
            {{ s.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import programmePoints from '@/data/sdg_urls.js'

const FAVOURITES_KEY = 'think-green:favourite-programmePoints'

export default {
  name: 'Programme',
  data() {
    return {
      programmePoints: programmePoints,
      favourites: [],

      onlyFavourites: false,
    }
  },
  created() {
    let storedFavourites = JSON.parse(localStorage.getItem(FAVOURITES_KEY))
    if(storedFavourites)
      this.favourites = storedFavourites
  },
  methods: {
    goto(s) {
      this.$router.push('/sdg/'+s.url)
    },
  },
  watch: {
    favourites() {
      localStorage.setItem(FAVOURITES_KEY, JSON.stringify(this.favourites))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sdglist-container {
  text-align: center;
  position: relative;
  padding-top: 30px;
}

.filter-container {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 20px;
}

.tile {
  height: 40vw;
  width: 40vw;
  max-width: 200px;
  max-height: 200px;
  display: inline-block;
  cursor: pointer;

  @include shadow;
  border-radius: $border-radius;
  margin: 10px;
  overflow: hidden;

  position: relative;

  color: black;
  background-color: white;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.tile-header{
  margin-top: 10px;
  padding: 10px;
  font-family: 'Arvo', serif;
  text-align: center;
  font-size: 0.9em;
}

.tile-text{
  font-family: 'PT Sans', serif;
  text-align: center;
  font-size: 0.8em;
}

.top-divider-black {
  border-top: 2px solid $primary;
  margin-bottom: 4px;
}

.bottom-divider-black {
  border-top: 2px solid $primary;
  margin-bottom: 4px;
}



.fav-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  padding-left: 10px;
  padding-top: 10px;
}
.favourite {
  color: $green;
}
</style>
